module.exports = __webpack_public_path__ + "img/desktop/Background/background@2x.jpg?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/desktop/Background/background@2x.jpg
// module id = 546
// module chunks = 0